import React from 'react'
import { Path } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { AccessibleIcon } from 'ui/svg/icons/types'

const HappyFaceSvg: React.FunctionComponent<AccessibleIcon> = ({
  size,
  color,
  accessibilityLabel,
  testID,
}) => {
  const height = typeof size === 'string' ? size : ((size as number) * 156) / 200
  return (
    <AccessibleSvg
      width={size}
      height={height}
      viewBox="0 0 200 156"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <Path
        d="M100.252 18.5C133.389 18.5 160.252 45.3629 160.252 78.5C160.252 91.8908 155.846 104.623 147.856 115.024C146.794 116.407 144.811 116.667 143.428 115.605C142.045 114.543 141.786 112.56 142.848 111.177C149.999 101.87 153.937 90.4874 153.937 78.5C153.937 48.8509 129.901 24.8154 100.252 24.8154C70.6005 24.8154 46.5674 48.8497 46.5674 78.5C46.5674 108.15 70.6005 132.185 100.252 132.185C107.523 132.185 114.592 130.738 121.146 127.968C122.752 127.289 124.605 128.041 125.284 129.647C125.964 131.253 125.212 133.105 123.605 133.784C116.277 136.881 108.371 138.5 100.252 138.5C67.1125 138.5 40.252 111.638 40.252 78.5C40.252 45.3617 67.1125 18.5 100.252 18.5ZM73.2012 84.9834C74.3029 83.556 76.3217 83.3318 77.708 84.4814C84.748 90.3203 93.9061 93.1848 103.323 92.2705C110.145 91.6076 116.475 89.0246 121.689 84.8877C123.091 83.7769 125.105 84.0574 126.189 85.5156C127.273 86.9727 127.016 89.055 125.615 90.167C119.455 95.0527 111.989 98.0993 103.969 98.8799C92.8854 99.9553 82.066 96.5705 73.7197 89.6494C72.3324 88.4998 72.1008 86.4108 73.2012 84.9834ZM83.1094 66.5C85.3207 66.5002 87.1094 68.2921 87.1094 70.5C87.1094 72.7125 85.3207 74.4998 83.1094 74.5C80.9014 74.5 79.1094 72.7126 79.1094 70.5C79.1094 68.292 80.9014 66.5 83.1094 66.5ZM116.252 66.5C118.46 66.5 120.252 68.292 120.252 70.5C120.252 72.7126 118.46 74.5 116.252 74.5C114.041 74.5 112.252 72.7126 112.252 70.5C112.252 68.292 114.041 66.5 116.252 66.5Z"
        fill={color}
      />
    </AccessibleSvg>
  )
}

export const HappyFace = styled(HappyFaceSvg).attrs(({ color, size, theme }) => ({
  color: color ?? theme.designSystem.color.icon.default,
  size: size ?? theme.illustrations.sizes.medium,
}))``
